
const PortalUtils = {
  portalMapping: {
    home: process.env.VUE_APP_HOME,
    learn: process.env.VUE_APP_LEARNING,
    press: process.env.VUE_APP_PRESS,
    collab: process.env.VUE_APP_COLLAB,
    advisory: process.env.VUE_APP_ADVISORY
  },
  // TODO: downscale base icon
  portalFaviconMapping: {
    home: require('@/assets/images/favicon.png'),
    learn: require('@/assets/images/favicon.png'),
    press: require('@/assets/images/logo/Signature_logo.png'),
    collab: require('@/assets/images/logo/4Cats_logo.png'),
    advisory: require('@/assets/images/logo/PACO_logo.png')
  },
  portalLogoMapping: {
    home: require('@/assets/images/favicon.png'),
    learn: require('@/assets/images/favicon.png'),
    press: require('@/assets/images/logo/Signature_logo_with_text.png'),
    collab: require('@/assets/images/logo/4Cats_logo_with_text.png'),
    advisory: require('@/assets/images/logo/PACO_logo_with_text.png')
  },
  portalTitleMapping: {
    home: 'The Thinkers Club',
    learn: 'The Thinkers Club',
    press: 'PACO Signature Asia Limited',
    collab: '4 Cats Limited',
    advisory: 'PACO COMMUNICATIONS LIMITED'
  },
  /**
   * @return {string[]} list of Portal
   * @example ['home', 'learn', 'press', 'collab', 'advisory']
   */
  get portals () {
    return Object.keys(this.portalMapping)
  },
  get name () {
    const target = window.location.origin + '/'
    // find the Portal
    for (const key in this.portalMapping) {
      if (target === this.portalMapping[key]) { return key }
    }
    return 'home'
  },
  getOrigin (name = this.name) {
    return this.portalMapping[name]
  },
  checkIsLocalhost () {
    return window.location.host.includes('localhost')
  },
  checkPortalMapping () {
    for (const key in this.portalMapping) {
      const a = this.portalMapping[key]
      // confirm all origin is mapped
      if (!a) throw new Error(`Portal '${key}' is not mapped \n check env file`)
      // confirm all origin start with 'http://' or 'https://'
      if (!a.startsWith('http://') && !a.startsWith('https://')) { throw new Error(`Portal '${key}' is not start with 'http://' or 'https://' \n check env file`) }
      // confirm all origin end with '/', if not throw error  }
      if (!a.endsWith('/')) { throw new Error(`Portal '${key}' is not end with '/' \n check env file`) }
    }
  }
}

function addFavicon () {
  const favicon = document.createElement('link')
  favicon.rel = 'shortcut icon'
  favicon.href = PortalUtils.portalFaviconMapping[PortalUtils.name]
  document.head.appendChild(favicon)
}
addFavicon()
PortalUtils.checkPortalMapping()
export { PortalUtils }
